'use strict';
; (function () {
    
    var OtpAuthorizationPopupModuleRoutes = [
        {
            "name": "emrOtpAuthorizationPopup",
            "url": "emrOtpAuthorizationPopup",
            "RoutingNumber": 4632,
            templateUrl: "AngularScripts/OtpAuthorization/Htmls/OtpAuthorizationPopup.html",
            files: [
                "AngularScripts/OtpAuthorization/Services/OTP_AuthorizationService.js",
                "AngularScripts/OtpAuthorization/Controllers/OtpAuthorizationPopupController.js",
            ]
        },
    ]

    angular.module('EMR.OtpAuthorizationPopupModule',[])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(OtpAuthorizationPopupModuleRoutes, $stateProvider);
            }]);
})();
